<template >
    <div >
      <q-layout view="hHh lpR fFf" >
        <q-header elevated class="bg-primary text-white" >
          <q-toolbar class="bg-primary">
            <div class="toolbar-wrapper">

              <div class="row">
                <div class="col-10">
                  <q-toolbar-title class="q-mt-sm">
                    <div class="row items-center">
                      <q-btn dense flat round icon="menu" @click="toggleLeftDrawer" aria-label="Open or close the left side content panel"/>
                      <a href="https://www.nature.org/en-us/what-we-do/our-priorities/protect-water-and-land/land-and-water-stories/marine-mapping-tool/" target="_blank"><img src="./assets/TNCLogoPrimary_RGB_Rev.png" height="40" alt="The Nature Conservancy logo"></a>
                      <a href="https://crcs.tnc.org/" target="_blank"><img src="./assets/CRCS_logo_white.png" class="q-pl-sm" height="40" alt="The Nature Conservancy logo"></a>
                      <div class="q-pl-md text-h5">
                        <span class="text-bold">MARINE MAPPING TOOL</span> | 
                        <span>NORTHEAST & MID-ATLANTIC </span>  
                        <div class="text-caption">Version {{ appVersion }} </div>
                      </div>
                    </div>
                  </q-toolbar-title>
                </div>
                <div class="col-2 right-text">
                  <q-btn @click="shareMap()" icon="share" class="q-pa-sm q-mt-sm" aria-label="Download map link">
                    <span class="q-pl-sm" >Share this map</span>
                  </q-btn>
                  <q-btn dense  size="xs" flat class="gray q-ml-md" icon="help_outline" @click.stop="infoDialogs['shareMapLink'].model = !infoDialogs['shareMapLink'].model" aria-label="'Copy Map Link' help"/>
                </div>
              </div>
              <div class="row">
                <div class="col">
                  <q-tabs align="left" active-color="secondary" dense class="q-mt-sm" v-model="activeTab" >
                    <q-tab name="/select" label="Select" @click="navigateTo('/select', 0)" class="my-tab"/>
                    <q-tab
                      v-for="version in resultVersions"
                      :key="`results-${version}`"
                      class="my-tab"
                      :name="`/results${version}/summary`"
                      :label="siteNames[String(version)] || `Area ${version}`"
                      @click="navigateTo(`/results${version}/summary`, version)"
                    />
                    <q-tab class="my-tab" name="/spSpotlight" v-if="activeSpSpotlight" label="Species Spotlight" @click="navigateTo('/spSpotlight', 0)" />
                    <q-tab class="my-tab" name="/habSpotlight" v-if="activeHabSpotlight" label="Habitat Spotlight" @click="navigateTo('/habSpotlight', 0)" />
                  </q-tabs>
                </div>
                  <div class="col right-text q-mt-sm">
                    <span><a href="https://www.maps.tnc.org/marinemap" class="text-white underline">Homepage</a></span> |
                    <span><a href="https://www.maps.tnc.org/marinemap/se" class="text-white underline">Southeast</a></span> |
                    <span>
                      <a @click="moreInfo = !moreInfo" class="text-white pointer">Feedback & More Info </a>
                    </span> | 
                    <span @click="splash = !splash" class="pointer">Welcome</span><br/>
                  </div>
              </div>
            </div>
          </q-toolbar>
        </q-header>

        <q-drawer  show-if-above :breakpoint="500" v-model="leftDrawerOpen" side="left" bordered ref="left-drawer" :width="ldWidth" class="no-scroll">
            <router-view />          
        </q-drawer>

        <q-page-container >
          <q-page style="min-height: inherit; min-width: inherit;">
            <Map />
          </q-page>
        </q-page-container>
      </q-layout>
    </div>
  <CookieBanner />

  <q-dialog v-model="splash" persistent aria-label="Marine Mapping Tool welcome screen" >
      <Splash @enter="splash = false" />
  </q-dialog>
  <q-dialog v-model="shareDialog" persistent >
      <ShareMapDialog @enter="shareDialog = false" :b64URL="b64URL"/>
  </q-dialog>
  <q-dialog v-model="moreInfo" aria-label="Welcome dialog">
    <MoreInfo />
  </q-dialog>
  <div v-for="(infoObj, name) in infoDialogs" :key="name">
    <q-dialog v-model="infoObj.model" :aria-label="infoObj.pName">
        <InfoDialog  :html="infoObj.text" :name="infoObj.pName"/>
    </q-dialog>
  </div>

</template>

<script setup lang="ts">
// @ts-nocheck
  import { ref, onMounted, computed, watch } from 'vue'
  import { useQuasar, LocalStorage } from 'quasar'
  import Map from "./components/Map.vue";
  import Splash from "./components/Splash.vue"
  import InfoDialog from "./components/InfoDialog.vue";
  import { event } from 'vue-gtag'
  import { useMapItems } from "./composables/useMapItems"
  import { useHelpers } from "./composables/useHelpers"
  import { useRouter, useRoute } from 'vue-router'

  import SpeciesIcon from '/SPECIES.svg?raw';
  import FeaturesIcon from '/FEATURES.svg?raw';
  import PeopleIcon from '/PEOPLE.svg?raw';
  import CoastalIcon from '/COASTAL.svg?raw';
  import SelectAreaIcon from '/SELECT_AREA.svg?raw';
  import SpSelectIcon from '/SELECTSPECIES.svg?raw';
  import SpSelectV2Icon from '/SELECTSPECIESv2.svg?raw';
  import SpeciesV2Icon from '/SPECIESv2.svg?raw';
  import FeaturesV2Icon from '/FEATURESv2.svg?raw';
  import PeopleV2Icon from '/PEOPLEv2.svg?raw';
  import CoastalV2Icon from '/COASTALv2.svg?raw';
  import ShareMapDialog from './components/ShareMapDialog.vue';
  import MoreInfo from "./components/MoreInfo.vue";
  import CookieBanner from './components/CookieBanner.vue';
  const router = useRouter()
  const route = useRoute()

  const { showResultTabLabels, map, mapLoaded, styleMap, zoomToPolygon,   setReleaseDate, activeSpSpotlight, setActiveSpSpotlight, activeHabSpotlight, setActiveSpGroups, setActiveCoastalHabitat, setActiveFlagType, setActiveFlagValue, setActiveHabSpotlight, setAppVersion, appVersion, loadDataByID, setLoading, queryParams, setQueryParams, cellData, siteNames, base64QueryString, setBase64QueryString, processedData, loadSavedProcessedData,setActivePane } = useMapItems()
  const { base64ToObj, objToBase64, removeAfterKey, errorMessages, setErrorMessages } = useHelpers()

  const app_version = "2.1.1"
  const release_date = "Jun 16, 2026"
  setAppVersion(app_version)
  setReleaseDate(release_date)

  const b64URL = ref(null)
  const shareMap = async() =>{
    b64URL.value = await getB64Link()
    shareDialog.value = !shareDialog.value
  }
  const leftDrawerOpen = ref(true)

  const toggleLeftDrawer = () => {
    leftDrawerOpen.value = !leftDrawerOpen.value
  }

  const cookieConsentKey = getCookieConsentKey()
  function getCookieConsentKey() {
    const base = import.meta.env.BASE_URL || '/'
    const suffix = base === '/' || base === ''
      ? ''
      : '-' + base.replace(/^\/+|\/+$/g, '').replace(/\//g, '-')
    return `cookie-consent${suffix}`
  }
  
  const getB64Link = ()=>{
    setBase64QueryString(objToBase64(processedData.value))
    // console.log(route.fullPath)
    const b64URL = window.location.origin + import.meta.env.BASE_URL + "#" + route.fullPath +"?b64="+ base64QueryString.value;
    return b64URL
  } 
  
  // SHARE MAP LINK
  const rdWidth=ref(400)
  
  const ldWidth = computed(() =>{
    if (!showResultTabLabels.value){
      return 600
    }
    else{
      return 733
    }
  })

  const infoDialogs = ref({

    shareMapLink: {
      pName: "Share This Map",
      model: false,
      text: "Clicking on the 'Share This Map' button will open a dialog panel with options for saving or sharing the Area of Interest for future use. There are one or two options in the dialog panel which generate a special URL which stores many aspects of the current state of the map, including the AOI(s) entered, the active section of the tool, and any data that has been processed within the tool.  The processed data makes return visits to the tool substantially faster, particularly in the case of large AOIs. <div class='q-pt-sm'>Within this dialog, the option to download an HTML file (shortcut with embedded data) is always present and, when less data is included, the option to copy the link to your computer's clipboard is also presented as an option.</div>"
    },
  })



  const splash = ref(true)
  const shareDialog = ref(false)
  const activeTabPath = ref('');

  const extractResultVersionFromPath = (path: string) => {
    const match = path.match(/^\/results(\d+)(?:\/|$)/)
    return match ? Number(match[1]) : null
  }

  const numericResultKeys = (obj: Record<string, unknown>) => {
    return Object.keys(obj)
      .filter((key) => /^\d+$/.test(key))
      .map((key) => Number(key))
  }

  const resultVersions = computed(() => {
    const versions = new Set<number>([
      ...numericResultKeys(cellData.value as Record<string, unknown>),
      ...numericResultKeys(processedData.value as Record<string, unknown>)
    ])

    return Array.from(versions)
      .filter((version) => (cellData.value as any)[version] || (processedData.value as any)[version])
      .sort((a, b) => a - b)
  })

  const activeTab = computed({
  get() {
    if (activeTabPath.value) return activeTabPath.value;
    const resultVersion = extractResultVersionFromPath(route.path);
    if (resultVersion !== null) return `/results${resultVersion}/summary`;
    if (route.path.startsWith('/spSpotlight')) return '/spSpotlight';
    if (route.path.startsWith('/habSpotlight')) return '/habSpotlight';
    return '/select';
  },
  set(value) {
    // console.log("setting path to",  value)
    activeTabPath.value = value;
  }
});

  const navigateTo = (path, version) => {
    // if going back to select a new AOI, add to Flag data before AOI is entered
    if (path.includes('select')){
      // version # doesn't matter since going back to select, but need to include something
      loadDataByID('FLAGS', 1)
    }
    router.push(path);

    // if moving between AOIs, force back to flgas
    if (path.includes('result')){
      setActivePane('summary')
      // console.log(processedData.value[version]['poly'])
      const p = makeCleanJson(processedData.value[version]['poly'], version)
      zoomToPolygon(p)
    }

  };

  const makeCleanJson = (content, version) =>{
      const userPoly = {
          type: "FeatureCollection",
          features:[],
          id: `userPoly_${version}`
      } as any;
      content['features'].forEach((feat)=>{
          userPoly.features.push(feat)
      })
      return userPoly
  }

const extractNumber = (path) => {
  const match = path.match(/\/results(\d+)\//);
  return match ? match[1] : null;
}
const myIcons = {
  species: SpeciesIcon,
  features: FeaturesIcon,
  people: PeopleIcon,
  coastal: CoastalIcon,
  selectArea: SelectAreaIcon,
  spSelect: SpSelectIcon,
  spSelectV2: SpSelectV2Icon,
  speciesV2: SpeciesV2Icon,
  featuresV2: FeaturesV2Icon,
  peopleV2: PeopleV2Icon,
  coastalV2: CoastalV2Icon,
};

  const clearCache = () => {
    if ('caches' in window) {
      caches.keys().then((names) => {
        names.forEach((name) => {
          // console.log(`Deleting cache: ${name}`)
          caches.delete(name);
        });
      });
    }
  }

  // set the active tab if the route changes
  watch(route, (newRoute) => {
    const pathSegments = newRoute.path.split('/');
    const resultsIndex = pathSegments.findIndex(segment => segment.startsWith('results'));
    if (resultsIndex !== -1) {
      activeTab.value = `/${pathSegments[resultsIndex]}/summary`;
    } else if (newRoute.path.startsWith('/spSpotlight')) {
      activeTab.value = '/spSpotlight';
    } else if (newRoute.path.startsWith('/habSpotlight')) {
      activeTab.value = '/habSpotlight';
    } else {
      activeTab.value = '/select';
    }
  }, { immediate: true });


  onMounted(() => {

    clearCache()
    router.isReady().then(async () => {
      // console.log("router ready")
      // console.log(route)
      if (Object.keys(route.query).length > 0) {
        const compressedB64 = route.query['b64']
        if (compressedB64){
          // console.log(compressedB64)
          
          const savedObj = await base64ToObj(compressedB64)
          // console.log(savedObj)
          let v
          if (route.fullPath.includes("results")){
            v = route.fullPath.split("/")[1].replace("results", "")
          }
          else{v="1"} // if select tab, just make it version 1
         

          // if there was a species selected for spotlight, set that
          if (savedObj['spSpotlight']){
            setActiveSpSpotlight(savedObj['spSpotlight'])
          }

          // if there was a species selected for spotlight, set that
          if (savedObj['habSpotlight']){
            setActiveHabSpotlight(savedObj['habSpotlight'])
          }

          // if there's a species group selected, make that active
          if (savedObj['activeSpGroups']){
            for (const [theme, value] of Object.entries(savedObj['activeSpGroups'])) {
              setActiveSpGroups(theme, value);
            }
          }

          // if there's a coastal habitat selected, make that active
          if (savedObj['activeCoastalHabitat']){
              setActiveCoastalHabitat(savedObj['activeCoastalHabitat']);
          }

          // if there's a coastal habitat selected, make that active
          if (savedObj['activeFlagType']){
            setActiveFlagType(savedObj['activeFlagType']);
          }

          // if there's a coastal habitat selected, make that active
          if (savedObj['activeFlagValue']){
              setActiveFlagValue(savedObj['activeFlagValue']);
          }

          // rather than all the logic that's used when updating processedData,
          // here is can just be swapped in wholesale
          // loadSavedProcessedData(savedObj)

          // // this was an attempt to load the nested route from saved URL.  Not there yet
          if (mapLoaded.value){
            loadSavedProcessedData(savedObj)
            // if the map is styled, set that
            if(savedObj['mapStyle']){

              // console.log(savedObj['mapStyle'])
              const layerID =  savedObj['mapStyle']['layerID']
              const attr =  savedObj['mapStyle']['attr']
              const type =  savedObj['mapStyle']['type']
              const stops =  savedObj['mapStyle']['stops']
              const valueNames =  savedObj['mapStyle']['valueNames']

              loadDataByID(layerID, v)
              map.value.once('idle', function(){
                styleMap(layerID, attr, type, stops, valueNames);
              })
            }
          }
          else{
            watch(mapLoaded, (newValue, oldValue) => {
              if (newValue){
                // Do something when someVariable changes
                loadSavedProcessedData(savedObj)
                
                // if the map is styled, set that
                if(savedObj['mapStyle']){
                  // console.log(savedObj['mapStyle'])
                  const layerID =  savedObj['mapStyle']['layerID']
                  const attr =  savedObj['mapStyle']['attr']
                  const type =  savedObj['mapStyle']['type']
                  const stops =  savedObj['mapStyle']['stops']
                  const valueNames =  savedObj['mapStyle']['valueNames']

                  loadDataByID(layerID, v)
                  
                  map.value.once('idle', function(){
                    styleMap(layerID, attr, type, stops, valueNames);
                  })
                  
                }
              }

            }, { once: true });
          }

          // clear the b64 query parameter
          router.push({ query: {} });

          if (route.fullPath.includes('results')){
            // remove the b64 strong from the fullPath
            const pane = removeAfterKey(route.fullPath.split("/")[2], "?")
            setActivePane(pane)
          }
        }

      }

      // if URL is results or if activeSpSpotlight is null, then push to Select
      else if ((route.fullPath != '/spSpotlight' && route.fullPath != '/habSpotlight') || !activeSpSpotlight.value || !activeHabSpotlight.value){
        router.push("/select")
      }
    })
    .catch((err) => console.log(`error ${err}`))
    
    const $q = useQuasar()
    
    $q.iconMapFn = (iconName) => {
      const icon = myIcons[iconName];
      if (icon !== undefined) {
        return { icon };
      }
    };

    // Initialize analytics if cookies were previously accepted
    const consent = LocalStorage.getItem(cookieConsentKey)
    if (consent === 'accepted') {
      // Initialize Google Analytics
      initGoogleAnalytics()
    }

    // $q.dark.set('auto') // or false or "auto"
  });
  const moreInfo = ref(false)

  const initGoogleAnalytics = () => {
    if (!window.gtag) {
      const script = document.createElement('script')
      script.async = true
      script.src = 'https://www.googletagmanager.com/gtag/js?id=G-GGFNTR0EV9'
      document.head.appendChild(script)
      
      window.dataLayer = window.dataLayer || []
      window.gtag = function() { dataLayer.push(arguments) }
      window.gtag('js', new Date())
      window.gtag('config', 'G-GGFNTR0EV9')
    }
  }

  // Capture uncaught errors
  window.onerror = (message, source, lineno, colno, error) => {
      let errs = errorMessages.value;
      const errorReport = `Error: ${message}\nSource: ${source}\nLine: ${lineno}\nColumn: ${colno}\nError Object: ${error ? error.stack : 'N/A'} \n`;
      errs.push(errorReport);
      setErrorMessages(errs)

      // Log to verify the function is executing
      // console.log('Uncaught error captured:', errorReport);
  };

</script>
<style>
.hidden{
  visibility: hidden;
}
body{
  /* adding d3 graphs made body overflow scroll unnecessarily, so hide */
  overflow: hidden;
}
.pointer{
  cursor: pointer;
}
.app-serif-font{
font-family: Merriweather;
}
.right-text{
  text-align: right;
}
.toolbar-wrapper{
  width: 100%;
}
.q-tab--active{
  background-color: white;
  border-radius: 5px 5px 0px 0px; 
  
}
.myLink{
    color: #1C7D73;
    text-decoration:underline;
    cursor: pointer;
}
.underline{
    text-decoration: underline;
}
.hide{
  display:none;
}
.my-tab{
  max-width: 160px; 
  white-space: nowrap; 
  overflow: hidden; 
  text-overflow: ellipsis !important;
}
</style>
